export interface CustomerResponse {
  id: number
  name: string
  status: string
  vat: string
  address: Array<CustomerAddressResponse>
  language: string
  languageId: number
  invoiceByPost: string
  invoiceByPeppol: number
  peppolId: string
  emailAddressInvoice: string
}
export interface CustomerAddressResponse {
  addressType: string
  street: string
  streetNumber: string
  streetNumberAlpha: string
  bus: string
  zipCode: string
  city: string
  countryId: 0
  country: string
}
export interface CustomerContactResponse {
  name: string
  firstName: string
  emailAddress: string
  mobilePhone: string
  fixedPhone: string
  language: {
    languageId: 0
    desc: string
  }
}

export interface leaderboardItem {
  id: number
  msisdn: string
  firstName: string
  lastName: string
  label: string
  volume: number
  cost: number
}

export const isCustomerAddressResponse = (address: any): address is CustomerAddressResponse => {
  if (address === undefined) {
    return false
  }
  return 'street' in address
}
export const isCustomerResponse = (customer: any): customer is CustomerResponse => {
  if (customer === undefined) {
    return false
  }
  return 'vat' in customer
}
export const isMonitoringLinkResponse = (link: any): link is string => {
  return link.length >= 1
}

export const isLeaderboardResponse = (data: any): data is leaderboardItem[] => {
  if (!Array.isArray(data) || data.length === 0) {
    return false
  }
  const first = data[0]
  return (
    typeof first === 'object' &&
    first !== null &&
    'volume' in first &&
    typeof first.volume === 'number' &&
    'id' in first &&
    typeof first.id === 'number'
  )
}
